var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { EventEmitter } from 'events';
import { AppJsApi } from './../common/config';
import { AppDownloadStatus } from '../../../common/constants';
import loadJs from '../common/loadjs';
import { createDeeplink } from '../common/scheme';
import { errorLogger } from '../../debug';
import { AppPackage } from '../common/appInfo';
/**
 * WS下载器
 * https://docs.qq.com/sheet/BqI21X2yZIht1KWr0C4P09Pa3MC1oZ0tSSlE4Ie6X13tslse1IQmKC2Cjyb92lYcaR3R7LnS1sldVh2qNJ6s2?tab=BB08J2
 *
 * TBS下载器实现
 * 相关文档：http://tbs.wsd.com
 */
var WSDownloader = /** @class */ (function (_super) {
    __extends(WSDownloader, _super);
    function WSDownloader(opt) {
        var _this = _super.call(this) || this;
        _this.name = 'WSDownloader';
        _this.opt = __assign({}, opt);
        var url = opt.url, appId = opt.appId, filename = opt.filename, packagename = opt.packagename, channelId = opt.channelId, active = opt.active;
        _this.wsApp = {
            appName: filename,
            appId: appId,
            url: url,
            packageName: packagename,
            appChannelId: channelId,
            versionCode: 0,
            autoOpen: 1,
            applink: active,
            // md5: "D2DC6D41BD7856D32C6321EFD84F6F5B",
            myAppConfig: "0",
            oplist: "1;2",
            extraData: "smp"
        };
        return _this;
    }
    WSDownloader.prototype.ready = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadJs([AppJsApi.WS, AppJsApi.TBS])];
                    case 1:
                        _a.sent();
                        this.regAdStat();
                        return [2 /*return*/];
                }
            });
        });
    };
    WSDownloader.prototype.listenDownloadState = function () {
        var _this = this;
        var _a;
        if ((_a = window.mqq) === null || _a === void 0 ? void 0 : _a.invoke) {
            window.mqq.invoke('event', 'addEventListener', {
                event: 'yybDownloadState'
            }, function (rst) {
                var _a = rst.data.data, data = _a === void 0 ? {} : _a;
                console.log('currentApp', data);
                _this.downPercent = (data === null || data === void 0 ? void 0 : data.downPercent) || 0;
                _this.state = (data === null || data === void 0 ? void 0 : data.state) || 0;
            });
        }
        else {
            errorLogger('异常:', 'window.mqq.invoke', '无此方法');
        }
    };
    WSDownloader.prototype.start = function () {
        var _this = this;
        var _a, _b, _c;
        var _d = this.opt, url = _d.url, appId = _d.appId, filename = _d.filename, packagename = _d.packagename, channelId = _d.channelId, reportstring = _d.reportstring, reportstring1 = _d.reportstring1, reportstring2 = _d.reportstring2, _e = _d.needautoinstall, needautoinstall = _e === void 0 ? true : _e, rest = __rest(_d, ["url", "appId", "filename", "packagename", "channelId", "reportstring", "reportstring1", "reportstring2", "needautoinstall"]);
        if ((_a = window.mqq) === null || _a === void 0 ? void 0 : _a.invoke) {
            window.mqq.invoke('commercial', 'startDownload', { appInfo: this.wsApp }, function (rst) {
                _this.listenDownloadState();
            });
        }
        else if ((_c = (_b = window === null || window === void 0 ? void 0 : window.tbs) === null || _b === void 0 ? void 0 : _b.download) === null || _c === void 0 ? void 0 : _c.startDownload) {
            var errorCode = window.tbs.download.startDownload(__assign({ url: url, needautoinstall: Boolean(needautoinstall) }, rest));
            if (errorCode < 0) {
                this.emit('apierror', errorCode);
            }
        }
        else {
            errorLogger('异常:', 'startDownload', '无此方法');
        }
    };
    /**
        * 补充内核统计上报
        *  type 上报的环节(0:下载开始;1:下载结束;2:安装完成)
        */
    WSDownloader.prototype.regAdStat = function () {
        var _a, _b;
        var _c = this.opt, url = _c.url, reportstring = _c.reportstring, reportstring1 = _c.reportstring1, reportstring2 = _c.reportstring2;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.ad) === null || _b === void 0 ? void 0 : _b.reportMsgByURL) {
            window.tbs.ad.reportMsgByURL({
                'appUrl': url,
                'type': '0',
                'reportUrl': reportstring,
            });
            window.tbs.ad.reportMsgByURL({
                'appUrl': url,
                'type': '1',
                'reportUrl': reportstring1,
            });
            window.tbs.ad.reportMsgByURL({
                'appUrl': url,
                'type': '2',
                'reportUrl': reportstring2,
            });
        }
        else {
            errorLogger('异常:', 'reportMsgByURL', '无此方法');
        }
    };
    WSDownloader.prototype.pause = function () {
        var _a, _b, _c;
        var url = this.opt.url;
        if ((_a = window.mqq) === null || _a === void 0 ? void 0 : _a.invoke) {
            window.mqq.invoke('commercial', 'pauseDownload', { appInfo: this.wsApp }, function (rst) {
            });
        }
        else if ((_c = (_b = window === null || window === void 0 ? void 0 : window.tbs) === null || _b === void 0 ? void 0 : _b.download) === null || _c === void 0 ? void 0 : _c.pauseDownload) {
            window.tbs.download.pauseDownload({ url: url });
        }
        else {
            errorLogger('异常:', 'pauseDownload', '无此方法');
        }
    };
    WSDownloader.prototype.resume = function () {
        var _a, _b, _c;
        var url = this.opt.url;
        if ((_a = window.mqq) === null || _a === void 0 ? void 0 : _a.invoke) {
            window.mqq.invoke('commercial', 'continueDownload', { appInfo: this.wsApp }, function (rst) {
            });
        }
        else if ((_c = (_b = window === null || window === void 0 ? void 0 : window.tbs) === null || _b === void 0 ? void 0 : _b.download) === null || _c === void 0 ? void 0 : _c.resumeDownload) {
            window.tbs.download.resumeDownload({ url: url });
        }
        else {
            errorLogger('异常:', 'resumeDownload', '无此方法');
        }
    };
    WSDownloader.prototype.install = function () {
        var _this = this;
        var _a, _b, _c;
        var url = this.opt.url;
        if ((_a = window.mqq) === null || _a === void 0 ? void 0 : _a.invoke) {
            window.mqq.invoke('commercial', 'startDownload', { appInfo: this.wsApp }, function (rst) {
            });
        }
        else if ((_c = (_b = window === null || window === void 0 ? void 0 : window.tbs) === null || _b === void 0 ? void 0 : _b.download) === null || _c === void 0 ? void 0 : _c.installApp) {
            var errorCode = window.tbs.download.installApp({ url: url }, function (res) {
                if (res === void 0) { res = {}; }
                _this.emit('install', /install:/gi.test(res.ret || ''));
            });
            if (errorCode < 0) {
                this.emit('install_error', errorCode);
            }
        }
        else {
            this.emit('install_error');
            errorLogger('异常:', 'installApp', '无此方法');
        }
    };
    WSDownloader.prototype.open = function () {
        var _a, _b, _c;
        var _d = this.opt, packagename = _d.packagename, active = _d.active, posId = _d.posId;
        if (packagename === AppPackage.WS) {
            return location.href = active;
        }
        if ((_a = window.mqq) === null || _a === void 0 ? void 0 : _a.invoke) {
            window.mqq.invoke('commercial', 'openApp', { appInfo: this.wsApp }, function (rst) {
            });
        }
        if ((_c = (_b = window === null || window === void 0 ? void 0 : window.tbs) === null || _b === void 0 ? void 0 : _b.package) === null || _c === void 0 ? void 0 : _c.runApp) {
            return window.tbs.package.runApp({ packagename: packagename, url: active, PosID: posId, });
        }
        else {
            errorLogger('异常:', 'runApp', '无此方法');
        }
        if (active) {
            location.href = active;
        }
        else {
            location.href = createDeeplink(packagename);
        }
    };
    WSDownloader.prototype.isInstalled = function () {
        var _this = this;
        var packagename = this.opt.packagename;
        return new Promise(function (resolve, reject) {
            var _a, _b, _c;
            if ((_a = window.mqq) === null || _a === void 0 ? void 0 : _a.invoke) {
                window.mqq.invoke('commercial', 'queryInstall', { appInfoList: [_this.wsApp] }, function (rst) {
                    console.log('isInstalled', rst);
                    var _a = rst.data.installState, installState = _a === void 0 ? [] : _a;
                    var appStateInfo = installState.find(function (v) { return _this.wsApp.packageName === v.packageName; });
                    var state = (appStateInfo === null || appStateInfo === void 0 ? void 0 : appStateInfo.state) || 0;
                    // TODO: 返回是否安装的状态
                    resolve(state === 5);
                });
            }
            else if ((_c = (_b = window === null || window === void 0 ? void 0 : window.tbs) === null || _b === void 0 ? void 0 : _b.package) === null || _c === void 0 ? void 0 : _c.isApkInstalled) {
                var isInstalled = window.tbs.package.isApkInstalled({ packagename: packagename });
                resolve(Number(isInstalled) === 1);
            }
            else {
                resolve(false);
                errorLogger('异常:', 'isApkInstalled', '无此方法');
            }
        });
    };
    /**
     * ws状态信息
     * UNKNOWN = -1
     * DOWNLOAD_READY = 0
     * DOWNLOADING = 1
     * PAUSED = 2
     * WAITING = 3
     * DOWNLOADED = 4
     * INSTALLED = 5
     * DELETE_PKG = 6
     * ERROR = 7
     */
    WSDownloader.prototype.getStatus = function () {
        var _this = this;
        var _a, _b, _c;
        var url = this.opt.url;
        if ((_a = window.mqq) === null || _a === void 0 ? void 0 : _a.invoke) {
            return new Promise(function (resolve, reject) {
                window.mqq.invoke('commercial', 'queryInstall', { appInfoList: [_this.wsApp] }, function (rst) {
                    var _a;
                    console.log('getStatus', rst);
                    var _b = rst.data.installState, installState = _b === void 0 ? [] : _b;
                    var appStateInfo = installState.find(function (v) { return _this.wsApp.packageName === v.packageName; });
                    var state = (appStateInfo === null || appStateInfo === void 0 ? void 0 : appStateInfo.state) || 0;
                    console.log('getStatusCurrent', appStateInfo, state);
                    var formatState = (_a = {},
                        _a[-1] = AppDownloadStatus.TASK_STATUS_NONE,
                        _a[0] = AppDownloadStatus.TASK_STATUS_NONE,
                        _a[1] = AppDownloadStatus.TASK_STATUS_PROGRESS,
                        _a[2] = AppDownloadStatus.TASK_STATUS_PROGRESS,
                        _a[3] = AppDownloadStatus.TASK_STATUS_PROGRESS,
                        _a[4] = AppDownloadStatus.TASK_STATUS_COMPLETED,
                        _a[5] = AppDownloadStatus.TASK_STATUS_COMPLETED,
                        _a[6] = AppDownloadStatus.TASK_STATUS_DELETED,
                        _a[7] = AppDownloadStatus.TASK_STATUS_FAILED,
                        _a)[Number(state)] || AppDownloadStatus.TASK_STATUS_NONE;
                    console.log('getStatusCurrentFormat', formatState);
                    resolve(formatState);
                });
            });
        }
        if ((_c = (_b = window === null || window === void 0 ? void 0 : window.tbs) === null || _b === void 0 ? void 0 : _b.download) === null || _c === void 0 ? void 0 : _c.getDownloadStatus) {
            return window.tbs.download.getDownloadStatus({ url: url });
        }
        else {
            errorLogger('异常:', 'getDownloadStatus', '无此方法');
            return false;
        }
    };
    WSDownloader.prototype.getProgress = function () {
        var _this = this;
        var url = this.opt.url;
        return new Promise(function (resolve, reject) {
            var _a, _b, _c, _d, _e;
            if ((_a = window.mqq) === null || _a === void 0 ? void 0 : _a.invoke) {
                window.mqq.invoke('commercial', 'queryInstall', { appInfoList: [_this.wsApp] }, function (rst) {
                    var _a = rst.data.installState, installState = _a === void 0 ? [] : _a;
                    var appStateInfo = installState.find(function (v) { return _this.wsApp.packageName === v.packageName; });
                    console.log('getProgress', rst, appStateInfo);
                    var downPercent = (appStateInfo === null || appStateInfo === void 0 ? void 0 : appStateInfo.downPercent) || 0;
                    resolve(downPercent || _this.downPercent || 0);
                });
            }
            else if (((_c = (_b = window === null || window === void 0 ? void 0 : window.tbs) === null || _b === void 0 ? void 0 : _b.download) === null || _c === void 0 ? void 0 : _c.getDownloadFileTotalSize) && ((_e = (_d = window === null || window === void 0 ? void 0 : window.tbs) === null || _d === void 0 ? void 0 : _d.download) === null || _e === void 0 ? void 0 : _e.getDownloadProgress)) {
                var progress = 0;
                var totalSize = window.tbs.download.getDownloadFileTotalSize({ url: url });
                if (!Number.isNaN(totalSize) && Number(totalSize) !== 0) {
                    progress = Math.floor(window.tbs.download.getDownloadProgress({ url: url }) / totalSize * 100);
                }
                resolve(progress);
            }
            else {
                resolve(0);
                errorLogger('异常:', 'getDownloadFileTotalSize/getDownloadProgress', '无此方法');
            }
        });
    };
    return WSDownloader;
}(EventEmitter));
export default WSDownloader;
